import { PopoverTrigger } from "@faire/slate/private/popover/PopoverTrigger";
import React, { isValidElement, cloneElement } from "react";

interface IProps extends React.HTMLProps<HTMLElement> {
  /**
   * When true, makes TooltipTrigger behaves as a Toggletip Trigger.
   * It automaticallywraps the children in a button element.
   *
   * Toggletips are a special tooltip that is triggered by clicking or pressing a key,
   * while hovering or focusing on the trigger element doesn't open it.
   */
  addInteraction?: boolean;
}

export const TooltipTrigger: React.FC<IProps> = ({
  "aria-label": ariaLabel,
  addInteraction,
  children,
  ...props
}) => {
  if (addInteraction) {
    if (!isValidElement(children)) {
      // eslint-disable-next-line no-console
      console.error("TooltipTrigger must have a valid child element");
      return null;
    }
    const childrenProps = children.props as Record<string, unknown>;

    return (
      <PopoverTrigger {...props}>
        {cloneElement(children, {
          ...childrenProps,
          "aria-label": ariaLabel,
          "aria-hidden": false,
          role: undefined,
          tabIndex: 0,
        } as Record<string, unknown>)}
      </PopoverTrigger>
    );
  }

  return <PopoverTrigger {...props}>{children}</PopoverTrigger>;
};
